import Header from "../components/Header";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-ivory text-ink">
      <Header variant="light" />
      <section className="pt-36 pb-24 px-6 lg:px-10 max-w-3xl mx-auto">
        <p className="eyebrow mb-3">Privacy</p>
        <h1 className="font-display text-4xl lg:text-5xl tracking-tight mb-8">PRIVACY NOTICE</h1>
        <div className="space-y-6 text-ink/75 leading-relaxed text-sm">
          <p><strong className="text-ink">Data controller.</strong> Your information is collected and controlled by Global Life Group. For any question or request, contact <a href="mailto:team@globalifegroup.com" className="text-gold">team@globalifegroup.com</a>.</p>
          <p><strong className="text-ink">What we collect.</strong> When you join the list we collect your name, work email, and optionally your phone number and the interests you select.</p>
          <p><strong className="text-ink">Why we collect it.</strong> To respond to your enquiry and to send you updates, insights and invitations related to LUXEWELL.</p>
          <p><strong className="text-ink">How it is kept.</strong> Your information is stored securely and is never sold or shared for third-party marketing.</p>
          <p><strong className="text-ink">Your choices.</strong> You can unsubscribe at any time, or request access to or deletion of your information, by emailing <a href="mailto:team@globalifegroup.com" className="text-gold">team@globalifegroup.com</a>.</p>
        </div>
      </section>
    </div>
  );
}
